import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';
import { TypeModel } from '@klant/conversational-connector/models/Type.model';
import { MessageHandlerService } from '@klant/conversational-connector/services/message-handle-service/message-handler.service';

import { effect, inject, Injectable } from '@angular/core';

import { ConversationalChatStore } from '../../../../signal-stores/conversational-chat-store/conversational-chat.store';

@Injectable({ providedIn: 'root' })
export class FaqMessageService {
    private readonly conversationalChatStore = inject(ConversationalChatStore);
    private readonly messageHandlerService = inject(MessageHandlerService);

    public constructor() {
        effect(() => {
            if (this.conversationalChatStore.faqMessage()) {
                this.sendFaqMessage();
            }
        });
    }

    public sendFaqMessage(): void {
        const faqMessage = this.conversationalChatStore.faqMessage();
        const canSendFaqMessage = faqMessage && this.conversationalChatStore.chatFullyLoaded();

        if (!canSendFaqMessage) {
            return;
        }

        if (this.isChattingWithAgent()) {
            this.conversationalChatStore.setShowLiveChatFaqPopUp(true);
            this.conversationalChatStore.setFaqMessage(undefined);
            this.conversationalChatStore.setPreviouslySentFaqQuestion(undefined);
            return;
        }

        if (this.isSameAsPreviousFaq(faqMessage)) {
            return;
        }

        this.messageHandlerService.sendMessage(faqMessage);

        if (this.conversationalChatStore.chatVisibility() === ConversationalChatVisibility.MINIMIZED) {
            this.conversationalChatStore.setChatVisibility(ConversationalChatVisibility.OPEN);
        }
        this.conversationalChatStore.setFaqMessage(undefined);
        this.conversationalChatStore.setPreviouslySentFaqQuestion(faqMessage);
    }

    private isChattingWithAgent(): boolean {
        const messagesFromBotOrAgent = this.conversationalChatStore.chatMessages().filter((message) => !message.fromClient);

        if (!messagesFromBotOrAgent.length) {
            return false;
        }

        const lastMessageFromBotOrAgent = messagesFromBotOrAgent[messagesFromBotOrAgent.length - 1];

        return (
            (lastMessageFromBotOrAgent.type === TypeModel.PARTICIPANT_MESSAGE ||
                lastMessageFromBotOrAgent.type === TypeModel.PLAIN_TEXT_MESSAGE) &&
            lastMessageFromBotOrAgent.serviceName === 'livechat'
        );
    }

    private isSameAsPreviousFaq(faqQuestion: string): boolean {
        return faqQuestion === this.conversationalChatStore.previousFaqQuestion();
    }
}
